import React from 'react';
export function Recognition() {
  return <section aria-labelledby="familiar-title" className="w-full bg-cream-200 px-5 py-20 sm:py-24" data-id="element-125" data-mp="2hr0mnnqwmu8l">
      <div className="mx-auto grid max-w-content gap-12 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)]" data-id="element-126" data-mp="1klbksjj7sf55">
        <div data-id="element-127" data-mp="15v4e112kkkka">
          <h2 id="familiar-title" className="text-center font-display text-4xl font-semibold leading-tight tracking-tight text-plum-800 sm:text-left sm:text-5xl" data-id="element-128" data-mp="15vcnsk3eb9r9">
            ¿Te suena familiar?
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-plum-500" data-id="element-129" data-mp="11wn306g12pxl">
            Sabes que algo está mal. Quizás ya lo intentaste y volviste. Quizás todavía estás
            adentro, calculando cada palabra antes de decirla, siendo una versión de ti misma que
            solo existe cuando él está mirando.
          </p>
        </div>

        <div className="border-l border-rose-300 pl-6 sm:pl-10" data-id="element-130" data-mp="2haj9g0f4r4da">
          <p className="text-lg text-plum-500" data-id="element-131" data-mp="2max6knf70twj">Lo que más duele no es lo que él hace.</p>
          <p className="mt-3 font-display text-4xl font-semibold italic text-rose-500 sm:text-5xl" data-id="element-132" data-mp="1p2gnwkekkusq">
            Es no reconocerte.
          </p>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-plum-500" data-id="element-133" data-mp="1k2u8c4b9r2gr">
            <p data-id="element-134" data-mp="1yvnprva3pso2">
              Eso no es debilidad. Es lo que le pasa a cualquier mujer que estuvo suficiente tiempo
              en un ciclo diseñado para hacerla dudar de sí misma.
            </p>
            <p data-id="element-135" data-mp="166zz1k6l2b34">Y ese ciclo tiene salida. Pero no se rompe con más amor ni con más paciencia.</p>
            <p className="font-medium text-plum-800" data-id="element-136" data-mp="117ngvcqnps6v">
              Se rompe con claridad, con un plan y con las herramientas correctas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}